var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_1852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.99999H15.8334C15.0884 9.99999 14.4484 9.28583 14.3659 8.33333C14.1192 5.45833 13.7417 3.33333 12.075 3.33333C10.4084 3.33333 9.99169 6.31833 9.99169 9.99999C9.99169 13.6817 9.57502 16.6667 7.90836 16.6667C6.24169 16.6667 5.86502 14.5442 5.61752 11.6667C5.53419 10.7108 4.89502 9.99999 4.14836 9.99999H2.48169",
    stroke: "#FAFEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_1852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechText);
export default __webpack_public_path__ + "static/media/Speech_Text.700a8fb5757e9b0ae718e6f64fa2f1f0.svg";
export { ForwardRef as ReactComponent };